<template>
    <div>
        <v-layout row wrap>
            <v-flex sm12 md3 style="padding: 0 5px 0 5px">
                <v-card>
                    <v-toolbar class="primary-color" dense flat dark>
                        Search &amp; Filtering
                    </v-toolbar>
                    <v-card-text>
                        <v-text-field 
                            v-model="searchText" 
                            append-icon="search" 
                            label="Search Email" 
                            single-line 
                            hide-details
                            @keyup.enter="search" 
                        />
                        <v-radio-group v-model="emailRadio">
                            <v-label style="padding-top:8px !important;">Filter Email Bounces</v-label>
                            <v-layout row wrap>
                                <v-flex sm6>
                                    <v-radio label="Bounce" value="bounce" />
                                </v-flex>
                                <v-flex sm6>
                                    <v-radio label="Complaint" value="complaint" />
                                </v-flex>
                            </v-layout>
                        </v-radio-group>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn @click="searchText='';emailRadio='';search()">
                            Clear
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="search()"
                        >
                            Search
                        </v-btn>
                        <v-spacer/>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex sm12 md9>
                <v-card>
                    <v-toolbar flat color="primary" dark dense>
                        Email Bounces
                    </v-toolbar>
                    <v-card-text style="padding: 0;">
                        <v-data-table 
                            :items="bounces" 
                            :headers="headers" 
                            :pagination.sync="pagination"
                            :total-items="totalBounces" 
                            :rows-per-page-items="paginationStrings" 
                            :loading="loading"
                            item-key="id" 
                            disable-initial-sort
                        >
                            <template v-slot:no-data>
                                <tr>
                                    <td :colspan="headers.length">
                                        <div style="text-align: center; padding:25px;">
                                            <v-icon size="125px">find_in_page</v-icon>
                                            <h3>No Results</h3>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <template slot="items" slot-scope="item">
                                <tr>
                                    <td>
                                        <b>{{ item.item.email }}</b>
                                    </td>
                                    <td>
                                        {{ item.item.type }}
                                    </td>
                                    <td>
                                        {{ convertToLocal(item.item.created_at) }}
                                    </td>
                                    <td style="text-align: center;">
                                        <v-icon v-if="item.item.ignored">mdi-check</v-icon>
                                    </td>
                                    <td style="text-align: center">
                                        <v-icon @click="item.expanded = !item.expanded">mdi-chevron-down</v-icon>
                                    </td>
                                </tr>
                            </template>
                            <template slot="expand" slot-scope="item">
                                <v-card>
                                    <v-card-text>
                                        <v-layout
                                            row
                                            wrap
                                        >
                                            <v-flex sm12>
                                                <b>Message: </b>
                                            </v-flex>
                                            <v-flex 
                                                sm12 
                                                style="padding-right: 1em;font-family:monospace;max-height: 150px;overflow-x: hidden;text-overflow: ellipsis; font-size: small; word-wrap:break-word"
                                            >
                                                {{ item.item.message.replaceAll('\\n','').replaceAll('\\','') }}
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                    <v-card-actions
                                        v-if="!item.item.ignored"
                                    >
                                        <v-spacer/>
                                        <v-btn 
                                            flat 
                                            color="red"
                                            @click.stop="ignoring = item.item.email;promptIgnoreAck=true"
                                        >
                                            Ignore Email Problems
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </template>
                            <template slot="actions-append">
                                <v-tooltip left>
                                    <v-btn
                                        round
                                        flat
                                        fab
                                        small
                                        @click="downloadCsv()"
                                        slot="activator"
                                    >
                                        <v-icon
                                            color="green"
                                        >   
                                            table_chart
                                        </v-icon>
                                    </v-btn>
                                    <span>Download CSV<br /><small>Of Current Search Terms</small></span>
                                </v-tooltip>
                            </template>
                        </v-data-table>

                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog 
            v-model="successfulIgnoreDialog"
            max-width="350px"
            max-height="800px"    
        >
            <v-card>
                <v-toolbar
                    color="green"
                    text-color="white"
                    dark
                    flat
                    dense
                >   
                    Success
                </v-toolbar>
                <v-card-text>
                    Email problems have been succesfully ignored.
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        @click="closeIgnoreDialog()"
                    >
                        Close & Refresh
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog 
            v-model="promptIgnoreAck"
            width="550"
            max-height="800px"    
        >
            <v-card>
                <v-toolbar
                    color="yellow"
                    text-color="black"
                    flat
                    dense
                >   
                    Ignore Email Report
                </v-toolbar>
                <v-card-text>
                    <b>Ignoring all reports from {{ ignoring }}</b><br />
                    By ignoring these reports, you are re-enabling sending to this address. Please note this is a one time exception <b>only</b>. If more than 3 bounce reports are received, emails to this address may be suspended again. If this address reports messages as spam, emails will be permanently suspended.
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        @click="promptIgnoreAck = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="primary"
                        dark
                        @click="ignoreEmailProblems(ignoring)"
                    >
                        Mark Ignored
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import api from '@/api'
import pagination from '@/components/global/pagination'

export default {
    name: 'OrgEmailBounces',
    mixins: [
        pagination
    ],
    data() {
        return {
            searchText: '',
            bounces: [],
            emailRadio: '',
            headers: [
                { text: 'Email', value: 'email' },
                { text: 'Type', value: 'type' },
                { text: 'Date', value: 'created_at' },
                { text: 'Ignored', value: 'ignored', align: 'center' },
                { text: 'More Info', align: 'center', sortable: false }
            ],
            pagination: {},
            paginationStrings: [
                10, 25, 50
            ],
            expanded: [],
            loading: true,
            filter: null,
            ignoring: null,
            successfulIgnoreDialog: false,
            promptIgnoreAck: false
        }
    },
    computed: {
        totalBounces() {
            return this.pagination.totalItems
        }
    },
    methods: {
        fetch() {
            this.loading = true
            api.email.problems.list({
                search: this.searchText, 
                ordering: (this.pagination.descending ? '-' : '') + this.pagination.sortBy, 
                pageNum: this.pagination.page, 
                count: this.pagination.rowsPerPage,
                filter: this.filter || null
            }).then(data => {
                this.bounces = data.results
                this.pagination.page = data.page_number
                this.pagination.totalItems = data.count
                this.componentCreated = true
                this.loading = false
            })
        },
        downloadCsv(){
            api.email.problems.downloadCsv({
                search: this.searchText, ordering: (this.pagination.descending ? '-' : '') + this.pagination.sortBy, filter: this.emailRadio
            }).then(response => {
                let blob = new Blob([response.data])
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'Export_ContactEmailProblems_Report.csv'
                link.click()
            })
        },
        search () {
            this.pagination.page = 1
            var queryParam = {}, filterQueryParam = {}
            if (this.searchText) {queryParam['search'] = this.searchText}
            if (this.emailRadio) {filterQueryParam['type'] = this.emailRadio}
            if (Object.keys(filterQueryParam).length !== 0) {queryParam['filter'] = JSON.stringify(filterQueryParam)}
            this.$router.push({ query: queryParam })
        },
        ignoreEmailProblems (email) {
            this.promptIgnoreAck = false
            api.userform.contact.ignoreEmailProblems({'email': email})
                .then(response => {
                    if(response.data.ignored){
                        this.successfulIgnoreDialog = true
                    }
                })
        },
        closeIgnoreDialog () {
            this.successfulIgnoreDialog = false
            this.$router.go()
        }
    }
}
</script>
